import React from 'react';
import { Hero } from '../components/Hero';
import { LocalTrust } from '../components/LocalTrust';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
export function Home() {
  return <main data-id="element-1500">
      <Hero data-id="element-1501" />
      <LocalTrust data-id="element-1502" />
      <Services data-id="element-1503" />
      <HowItWorks data-id="element-1504" />
      <FAQ data-id="element-1505" />
      <Reviews data-id="element-1506" />
    </main>;
}